module.exports = __webpack_public_path__ + "static/media/KaWineAndDine_Badge_stay.5db183c8.jpg";